const ACTIONS = {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
  SET_INITIAL_DATA: 'set-data',
  TEXT_CHANGE: 'text-change',
  TEXT_SET_ERRORS: 'text-set-errors',
  TEXT_REMOVE_ERRORS: 'text-remove-errors',
  SELECT_CHANGE: 'select-change',
  SELECT_SET_ERRORS: 'select-set-errors',
  SELECT_REMOVE_ERRORS: 'select-remove-errors',
  DATE_CHANGE: 'date-change',
  DATE_SET_ERRORS: 'date-set-errors',
  DATE_REMOVE_ERRORS: 'date-remove-errors',
};

const formInfoReducer = (state, action) => {
  //console.log("dispatch triggered", state, action);

  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading
      };
    }
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
              errors: []
            }
          }

        }
      };
    }
    case ACTIONS.SELECT_CHANGE: {
      const path = state.data[action.name];

      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            value: action.value,
            options:
              path.options.map((option) => {
                // //console.log(option.value + " " + action.value);
                if (option.value == action.value) {
                  // //console.log("change");
                  option.isSelected = true;
                }
                else {
                  option.isSelected = false;
                }

                return option;

              }),
            validation: {
              ...path.validation,
              isInvalid: false,//isInvalidFunc(path.validation.required,action.value),
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {

      const path = state.data[action.name];

      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.SELECT_SET_ERRORS: {

      const path = state.data[action.name];

      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
              errors: action.errors
            }
          }
        }
      };
    }

    case ACTIONS.SELECT_REMOVE_ERRORS: {

      const path = state.data[action.name];

      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
  }
}

export { ACTIONS, formInfoReducer };